<template>
  <div class="picker-component">
    <van-popup v-model:show="showPicker" round position="bottom">
      <van-picker
        v-model="selectedValues"
        :title="title"
        :columns="columns"
        :confirm-button-text="confirmButtonText"
        :cancel-button-text="cancelButtonText"
        class="picker"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<!-- picker选择器
https://vant-ui.github.io/vant/#/zh-CN/picker

传参：
@title 标题
@confirmButtonText 确认按钮文案
@cancelButtonText 取消按钮文案

emit方法:
onConfirm 确认选项

示例：

  const countryPicker = ref<InstanceType<typeof Picker>>()
  const onConfirmCountry = (selectedOptions: { text: string }[]) => {
    countryPicker.value && (countryPicker.value.showPicker = false)
    info.country = selectedOptions[0].text
  }
  
  <Picker ref="countryPicker" :title="$t('editProfile.Country')" :confirmButtonText="$t('editProfile.Confirm')"
      @onConfirm="onConfirmCountry"></Picker>
 -->

<script lang="ts" setup>
interface columnsType {
  text: string
  value: string
}

interface selected {
  selectedOptions: string[]
}

defineOptions({
  name: 'Picker'
})

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  showPicker.value
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  confirmButtonText: {
    type: String,
    default: 'Confirm'
  },
  cancelButtonText: {
    type: String,
    default: ' '
  }
})

const emit = defineEmits(['onConfirm'])

const showPicker = ref(false)
const selectedValues = ref<string[]>([])
const { title, confirmButtonText, cancelButtonText } = toRefs(props)
const columns = ref<columnsType[]>([])
const onConfirm = ({ selectedOptions }: selected) => {
  emit('onConfirm', selectedOptions)
}

defineExpose({ showPicker, selectedValues, columns })
</script>

<style lang="scss">
@import './scss/index.scss';
</style>
